/**
 * Font size tokens
 */
export const fontSizes = {
  xxxs: '0.45rem',
  xxs: '0.45rem',
  xs: '0.66rem',
  sm: '0.79rem',
  md: '1rem',
  lg: '1.13rem',
  xl: '1.34rem',
  xxl: '2.44rem',
  xxxl: '4rem',
  xxxxl: '4.7rem',
  xxxxxl: '6.1rem',
}

/**
 * Z-Indexes tokens
 */
export const zIndices = {
  hide: -1,
  auto: 'auto',
  base: 0,
  docked: 10,
  dropdown: 1e3,
  sticky: 1100,
  banner: 1200,
  overlay: 1300,
  modal: 1400,
  popover: 1500,
  skipLink: 1600,
  toast: 1700,
  tooltip: 1800,
}

/**
 * Semantic tokens
 */
export const semanticTokens = {
  colors: {},
}

/**
 * Transitions tokens
 */
export const transition = {}

/**
 * Color tokens
 */
export const colors = {
  white: '#FFFFFF',
  orange: '#FF9249',
  softOrange: '#FFD9BE',
  softerOrange: '#F6AA74',
  softestOrange: '#FAC7A4',
  faintOrange: '#FFF9F5',
  softBlack: '#302C2E',
  softerBlack: '#646162',
  softestBlack: '#979596',
  gray: '#D2CDC8',
  softWhite: '#F0E9DE',
  softerWhite: '#F4EFE6',
  softestWhite: '#FAF5EE',
  blush: '#FF9BBC',
  softBlush: '#FFC4D8',
  gold: '#B19933',
  blue: '#82ADAE',
  softBlue: '#AFC9C9',
  green: '#6C804B',
  softGreen: '#D4D8CA',
  steel: '#7F8F8F',
  lilac: '#BDAEB6',
  softLilac: '#d6c7cf',
  successGreen: '#3E904B',
  failRed: '#B82929',
}

/**
 * Spacing tokens
 */
export const space = {
  xxxs: '0.1rem',
  xxs: '0.2rem',
  xs: '0.3rem',
  sm: '0.5rem',
  md: '0.8rem',
  lg: '1.3rem',
  xl: '2.1rem',
  xxl: '3.4rem',
  xxxl: '4.5rem',
}

/**
 * Breakpoint tokens
 */
export const breakpoints = {
  sm: '48rem',
  md: '64rem',
  lg: '80rem',
  xl: '90rem',
}

/**
 * Border tokens
 */
export const borders = {}

/**
 * Font weight tokens
 */
export const fontWeights = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 550,
  bold: 700,
  extrabold: 800,
  black: 900,
}

/**
 * Font tokens
 */
export const fonts = {
  body: 'Suisse Intl, sans-serif',
  heading: 'ABC Arizona Text, serif',
  mono: 'Suisse Intl Mono, monospace',
}

/**
 * Letter spacing tokens
 */
export const letterSpacings = {
  tighter: '-0.07em',
  tight: '-0.01em',
  normal: '0',
  wide: '0.01em',
  wider: '0.07em',
}

/**
 * Line height tokens
 */
export const lineHeights = {
  tighter: 0.9,
  normal: 'normal',
  shorter: 1,
  short: 1,
  base: 1.2,
  tall: 1.4,
  taller: 2,
}

/**
 * Html base line height, lineHeight is inherited as 1.5 across all our
 * elements
 */
export const htmlBaseLineHeight = 1.5

/**
 * Border radius tokens
 */
export const radii = {
  base: 0,
  full: '100%',
}

/**
 * Shadow tokens
 */
export const shadows = {
  md: 'rgba(0, 0, 0, 0.1) 0 4px 6px -1px, rgba(0, 0, 0, 0.06) 0 2px 4px -1px',
  lg: '0px 8px 14px 0px rgba(48, 44, 46, 0.15)',
}

/**
 * Container size tokens
 */
export const container = {
  sm: '31vw',
  md: '50vw',
  lg: '62vw',
  xl: '93vw',
}

/**
 * Size tokens
 */
export const sizes = {
  container,
  space,
  font: fontSizes,
  breakpoints,
  letterSpacings,
  max: 'max-content',
  min: 'min-content',
  full: '100%',
  summary: '36ch',
  prose: '60ch',
  article: '80ch',
}
